import React from 'react'

import './diamond-button.scss'
const DiamondButton = ({ onClick, href, className = '' }) => {
  return (
    <a
      className={'f-diamond-button ' + className}
      onClick={onClick || null}
      href={href || null}
    />
  )
}

export default DiamondButton
